import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';

import CarouselItems from './CarouselItems';
import type { CarouselSlideProps } from './types/CarouselSlideProps';

const useStyles = makeStyles((theme) =>
    createStyles({
        carouselSlideItems: {
            flexGrow: 0,
            flexShrink: 1,
            height: '100%',
            maxWidth: '600px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            justifyContent: 'space-between',
            paddingBottom: '28px',
            paddingRight: '32px',
            paddingLeft: '32px',
        },
        bottomRightBgImageContainer: {
            flexGrow: 1,
            flexShrink: 0,
            flexBasis: '0',
            minWidth: '0',
            position: 'relative',
            display: 'flex',
            maxHeight: '200px',
        },
        bottomRightImage: {
            maxWidth: '100%',
            maxHeight: '100%',
            position: 'absolute',
            bottom: '0px',
            right: '0px',
        },
        '@media all and (max-width: 1150px)': { bottomRightBgImageContainer: { display: 'none' } },
    }),
);

const CarouselSlideBottomRightImageStyle = ({
    lineImage,
    title,
    description,
    backgroundImage,
    buttonText,
    buttonRedirectUrl,
    buttonType,
    setOpen,
    idx,
    currSlide,
}: CarouselSlideProps) => {
    const classes = useStyles();
    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
                height: '100%',
            }}
            data-cy={`carousel-slide-${idx}`}
        >
            <div
                className={classes.carouselSlideItems}
                data-cy={`carousel-items-primary-${idx}`}>
                <CarouselItems
                    title={title}
                    description={description}
                    lineImage={lineImage}
                    buttonText={buttonText}
                    buttonType={buttonType}
                    buttonRedirectUrl={buttonRedirectUrl}
                    idx={idx}
                    currSlide={currSlide}
                    setOpen={setOpen}
                />
            </div>
            {backgroundImage && <div
                className={classes.bottomRightBgImageContainer}
                data-cy={`bottom-right-img-${idx}`}
            >
                <img
                    alt="" // decorative image no alt text needed
                    src={backgroundImage}
                    className={classes.bottomRightImage}
                />
            </div> }
        </div>
    );
};

export default CarouselSlideBottomRightImageStyle;
